import React, { useEffect } from 'react';
import * as d3 from 'd3';

const D3Graph = ({ results, x_axis_prefix, y_axis_prefix }:any) => {
  const svgId = `graph${x_axis_prefix}_${y_axis_prefix}`;

  useEffect(() => {
    let colors = [
      "#7fffd4", "#00ffff", "#000000", "#0000ff",
      "#8a2be2", "#a52a2a", "#deb887", "#5f9ea0",
      "#d2691e", "#7fff00", "#dc143c", "#a9a9a9",
      "#006400", "#9932cc",
    ];

    let data = [];
    let min_x;
    let max_x;
    let min_y;
    let max_y;




    for (const result of results) {
      let cx = result[`${x_axis_prefix}_average`];
      let cx_min = result[`${x_axis_prefix}_min`];
      let cx_max = result[`${x_axis_prefix}_max`];
      let cy = result[`${y_axis_prefix}_average`];
      let cy_min = result[`${y_axis_prefix}_min`];
      let cy_max = result[`${y_axis_prefix}_max`];

      min_x = (min_x === undefined) ? cx_min : Math.min(min_x, cx);
      max_x = (max_x === undefined) ? cx_max : Math.max(max_x, cx);
      min_y = (min_y === undefined) ? cy_min : Math.min(min_y, cy);
      max_y = (max_y === undefined) ? cy_max : Math.max(max_y, cy);

      data.push([
        cx,
        cy,
        Math.abs(cx_max - cx_min) / 2,
        Math.abs(cy_max - cy_min) / 2,
        result["Batteries_label"]
      ]);
    }

    max_x *= 1.3;
    max_y *= 1.2;

    let x_unit = 1.0 * Math.pow(10, ("" + Math.round(min_x)).length) / 100;
    let y_unit = 1.0 * Math.pow(10, ("" + Math.round(min_y)).length) / 100;

    // ... D3 rendering logic
    let margin = {top: 20, right: 20, bottom: 60, left: 60};
    let width = 400 - margin.left - margin.right;
    let height = 400 - margin.top - margin.bottom;

    let svg = d3.select(`#${svgId}`)
      .append("svg")
      .attr("width", width + margin.left + margin.right)
      .attr("height", height + margin.top + margin.bottom);

    let g = svg.append("g")
      .attr("transform", `translate(${margin.left}, ${margin.top})`);

    let x = d3.scaleLinear().domain([0, max_x / x_unit]).range([0, width]);
    let y = d3.scaleLinear().domain([0, max_y / y_unit]).range([height, 0]);

    g.append("g")
      .attr("transform", `translate(0, ${height})`)
      .call(d3.axisBottom(x));

    g.append("g")
      .call(d3.axisLeft(y));

    // ... additional D3 code to create ellipses, circles, and labels
    // ... D3 rendering logic to create ellipses, circles, and labels


    let i = 0;
    for (const [cx, cy, rx, ry, name] of data) {
        g.append("ellipse")
            .attr("cx", x(cx / x_unit))
            .attr("cy", y(cy / y_unit))
            .attr("rx", rx * width / max_x)
            .attr("ry", ry * height / max_y)
            .attr("stroke", colors[i])
            .attr("fill", "white")
            .attr("opacity", 0.6);

        i++;
    }

    for (const [cx, cy, rx, ry, name] of data) {
        g.append("circle")
            .attr("cx", x(cx / x_unit))
            .attr("cy", y(cy / y_unit))
            .attr("r", 1.5);
    }

    i = 0;
    for (const [cx, cy, rx, ry, name] of data) {
        g.append("text")
            .text(name)
            .attr("x", x(cx / x_unit))
            .attr("y", y(cy / y_unit))
            .attr("dx", 4)
            .attr("dy", 5)
            .attr("fill", colors[i]);

        i++;
    }


    g.append("text")
    .attr("text-anchor", "end")
    .attr("x", width)
    .attr("y", height + margin.top + 20)
    .text(`${x_axis_prefix.replaceAll('_', ' ')} (x ${x_unit})`);

  // For Y axis label
  g.append("text")
    .attr("text-anchor", "end")
    .attr("transform", "rotate(-90)")
    .attr("y", -margin.left + 20)
    .attr("x", -margin.top)
    .text(`${y_axis_prefix.replaceAll('_', ' ')} (x ${y_unit})`);


    return () => {
      // Cleanup function to remove the SVG if needed
      d3.select(`#${svgId}`).selectAll("*").remove();
    };

  }, [results, x_axis_prefix, y_axis_prefix]);

  return (
    <div id={svgId}></div>
  );
};

export default D3Graph;
